export const PENDING = 'pending'
export const APPROVED = 'approved'
